<div class="o-flex o-flex--column o-flex--justify-center u-padding-left-20 device-management-list u-margin-bottom-30 u-color-black-light">
  <span class="u-margin-bottom-8 u-font-weight-400 u-font-size-20 line-height-24 u-display-block">Management overview</span>
  <ul class="u-margin-reset unordered--padding-inline-start u-font-weight-400 u-font-size-14 line-height-20">
    <li>Maximum No of device allowed: <span class="u-font-weight-700">{{maximumDeviceNumber}}</span></li>
    <li>Currently used: <span class="u-font-weight-700">{{currentUsedDeviceNumber}}</span></li>
  </ul>
</div>
